import { css } from '@emotion/react';

const style = css`
  @font-face {
    font-family: 'antonio';
    src: url('./fonts/Antonio-VariableFont_wght.ttf') format('truetype');
    font-weight: 100 900;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'nunito-sans';
    src: url('./fonts/NunitoSans_7pt-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'nunito-sans';
    src: url('./fonts/NunitoSans_7pt-Italic.ttf') format('truetype');
    font-weight: normal;
    font-style: italic;
  }

  @font-face {
      font-family: 'nunito-sans';
      src: url('./fonts/NunitoSans_7pt-Light.ttf') format('truetype');
      font-weight: 200;
      font-style: normal;
  }

  @font-face {
      font-family: 'nunito-sans';
      src: url('./fonts/NunitoSans_7pt-LightItalic.ttf') format('truetype');
      font-weight: 200;
      font-style: italic;
  }

  @font-face {
    font-family: 'nunito-sans';
    src: url('./fonts/NunitoSans_7pt-ExtraLight.ttf') format('truetype');
    font-weight: 100;
    font-style: normal;
  }

  @font-face {
    font-family: 'nunito-sans';
    src: url('./fonts/NunitoSans_7pt-ExtraLightItalic.ttf') format('truetype');
    font-weight: 100;
    font-style: italic;
  }

  @font-face {
    font-family: 'nunito-sans';
    src: url('./fonts/NunitoSans_7pt-Regular.ttf') format('truetype');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'nunito-sans';
    src: url('./fonts/NunitoSans_7pt-Regular.ttf') format('truetype') format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'nunito-sans';
    src: url('./fonts/NunitoSans_7pt-SemiBold.ttf') format('truetype') format('truetype');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'nunito-sans';
    src:
      url('./fonts/NunitoSans_7pt-Bold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'nunito-sans';
    src:
      url('./fonts/NunitoSans_7pt-BoldItalic.ttf') format('truetype');
    font-weight: bold;
    font-style: italic;
  }

  @font-face {
    font-family: 'nunito-sans';
    src: url('./fonts/NunitoSans_7pt-Regular.ttf') format('truetype');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'nunito-sans';
    src:
      url('./fonts/NunitoSans_7pt-MediumItalic.ttf') format('truetype');
    font-weight: 600;
    font-style: italic;
  }

  @font-face {
    font-family: 'nunito-sans';
    src:
      url('./fonts/NunitoSans_7pt-Bold.ttf') format('truetype');
    font-weight: 800;
    font-style: normal;
  }

  @font-face {
    font-family: 'nunito-sans';
    src:
      url('./fonts/NunitoSans_7pt-Black.ttf') format('truetype');
    font-weight: 900;
    font-style: normal;
  }

  pre {
    font-family: 'nunito-sans', sans-serif;
    font-weight: normal;
    font-size: 1em;
  }

  code,
  kbd,
  samp {
    font-family: 'nunito-sans', sans-serif;
    font-size: 1em;
  }

  small {
    font-size: 80%;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: 'nunito-sans', sans-serif;
    word-wrap: break-word;
  }

  /* to override body margin from antd */
  .sb-show-main.sb-main-padded {
    margin: 0;
    padding: 0;
  }

  /* to override elipsis on dropdown options from antd */
  .ant-select-item-option-content {
    white-space: normal;
    height: auto;
  }

  h1,
  h2,
  h3,
  h4 {
    margin: 0;
    font-family: 'antonio', sans-serif;
  }

  h5,
  h6 {
    margin: 0;
    font-family: 'nunito-sans', sans-serif;
  }
  p,
  a {
    margin: 0;
    font-family: 'nunito-sans', sans-serif;
  }

  code {
    font-family: 'nunito-sans', sans-serif;
  }

  html {
    box-sizing: border-box;
    -webkit-text-size-adjust: 100%;
  }

  *,
  *:after,
  *:before {
    margin: 0;
    padding: 0;
    box-sizing: inherit;
  }

  *:focus {
    outline: none;
  }

  *:focus-visible {
    outline: #00E8FC solid 2px;
  }

  *:active {
    outline: none;
  }

  /* Audio: Remove big play button (leave only the button in controls). */
  .video-js.vjs-audio .vjs-big-play-button {
    display: none;
  }
  /* Audio: Make the controlbar visible by default */
  .video-js.vjs-audio .vjs-control-bar {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }
  /* Make player height minimum to the controls height so when we hide video/poster area the controls are displayed correctly. */
  .video-js.vjs-audio {
    min-height: 2rem;
  }

  .vjs-text-track-display {
    display: none;
  }

  // Remove recaptcha badge
  .grecaptcha-badge {
    visibility: hidden;
  }

  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background-color: #101949;
    color: white;
  }

  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background-color: #282F6A;
    color: white;
  }
  .ant-select-item-option {
    min-height: 40px;
  }
  .ant-select-item-option-content {
    font-size: 16px;
    display: flex;
    align-items: center;
  }

  .ant-radio-button-wrapper {
    :hover {
      .ant-typography {
        color: #101949 !important;
      }
    }
  }
  // .ant-input:focus,
  // .ant-input-password:focus,
  // .ant-input-search:focus,
  // .ant-input-affix-wrapper:focus,
  // .ant-select-selector:focus {
  //   border-color: inherit !important;
  //   outline: 0;
  //   -webkit-box-shadow: 0 0 0 0px rgba(87, 168, 233, 0.2);
  //   box-shadow: 0 0 0 0px rgba(87, 168, 233, 0.2);
  // }

  // .ant-input:hover,
  // .ant-input-password:hover,
  // .ant-input-search:hover,
  // .ant-input-affix-wrapper:hover,
  // .ant-select-selector:hover {
  //   border-color: inherit !important;
  //   outline: 0;
  //   -webkit-box-shadow: 0 0 0 0px rgba(87, 168, 233, 0.2);
  //   box-shadow: 0 0 0 0px rgba(87, 168, 233, 0.2);
  // }
`;

export default style;
